<script>
    export let tag;

    import {projects_values, researchers_values} from './data.js';
    import ResearcherCard from './ResearcherCard.svelte';
    import ProjectCard from './ProjectCard.svelte';
    import Tag from './Tag.svelte';

</script>

<main>
    <div class="row">
        <div class="col s12">
            <Tag tag="Experiments"/>
            <Tag tag="Modeling"/>
            <Tag tag="Data integration"/>
            <Tag tag="Clinics"/>
        </div>
        <h1 class="qualiperf">{tag}</h1>
    </div>
    <div class="row">
        <h2 class="qualiperf">Projects</h2>
        {#each projects_values as project (project.id)}
            {#if project.tags.indexOf(tag) >= 0}
                <div class="col s12 m6 l3">
                    <ProjectCard {project}/>
                </div>
            {/if}
        {/each}
    </div>
    <div class="row">
        <h2 class="qualiperf">Researchers</h2>
        {#each researchers_values as researcher (researcher.id)}
            {#if researcher.tags.indexOf(tag) >= 0}
                <div class="col s12 m4 l2">
                    <ResearcherCard {researcher}/>
                </div>
            {/if}
        {/each}
    </div>
</main>